export const limitsAndUsageExtras = {
  limitsAndConsumption: [
    {
      memberName: 'Elaine Benes',
      personCode: 'Member-1002',
      memberWaitingPeriodEndDate: '2023-11-05',
      limits: [
        {
          name: 'Chiro/Osteo Limit',
          totalAvailable: 750,
          totalConsumed: null,
          totalLimit: 750,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Chiropractic',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Osteopathy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Flexi Limit',
          totalAvailable: 1300,
          totalConsumed: null,
          totalLimit: 1300,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Ante-Post Natal',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Audiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Dietitian',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Exercise Physiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Eye Therapy ',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Occupational Therapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Podiatry',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Psychology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Speech Therapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Health and Wellbeing Limit',
          totalAvailable: 400,
          totalConsumed: null,
          totalLimit: 400,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Acupuncture',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Group Exercise Physiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Group Physiotherapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Myotherapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Remedial Massage',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Tests and Programs',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Laser Refractive Eye Surgery',
          totalAvailable: 1500,
          totalConsumed: null,
          totalLimit: 1500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Major Dental',
          totalAvailable: 1100,
          totalConsumed: null,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Surgical Tooth Removal',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Med Prescribed Devices & Apps',
          totalAvailable: 1500,
          totalConsumed: null,
          totalLimit: 1500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Appliance Maintenance',
              consumed: null,
              subLimitMaximum: 100,
              subLimitAvailable: 100,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Artificial Eye Limit',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Blood Glucose Monitor',
              consumed: null,
              subLimitMaximum: 500,
              subLimitAvailable: 500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Blood Pressure Monitor',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Compression Garment Limit',
              consumed: null,
              subLimitMaximum: 1500,
              subLimitAvailable: 1500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'EpiPen Limit',
              consumed: null,
              subLimitMaximum: 150,
              subLimitAvailable: 150,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'External Breast Prosthesis',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Foot Orthotics Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Hearing Aids',
              consumed: null,
              subLimitMaximum: 1500,
              subLimitAvailable: 1500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Irlen Lense Limit',
              consumed: null,
              subLimitMaximum: 100,
              subLimitAvailable: 100,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Join Fluid Rep Injects Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Mobility Aids Limit',
              consumed: null,
              subLimitMaximum: 1000,
              subLimitAvailable: 1000,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Nebuliser and Spacer Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Non-Cosmetic Prostheses',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Orthopaedic Shoes Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Pap Machine For Sleep Apnoea',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Rental Of Appliances',
              consumed: null,
              subLimitMaximum: 200,
              subLimitAvailable: 200,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Splints and Braces Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'TENS Machine Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Wig',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Optical Limit',
          totalAvailable: 300,
          totalConsumed: null,
          totalLimit: 300,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Orthodontic',
          totalAvailable: 1000,
          totalConsumed: null,
          totalLimit: 1000,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Pharmacy & Travel Vaccinations',
          totalAvailable: 500,
          totalConsumed: null,
          totalLimit: 500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Pharmacy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Travel Vaccinations',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Physiotherapy Limit',
          totalAvailable: 850,
          totalConsumed: null,
          totalLimit: 850,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'School Accidents',
          totalAvailable: 800,
          totalConsumed: null,
          totalLimit: 800,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Unlimited General Dental',
          totalAvailable: null,
          totalConsumed: null,
          totalLimit: null,
          unlimited: true,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
      ],
    },
    {
      memberName: 'David Puddy',
      personCode: 'Member-100200000000',
      memberWaitingPeriodEndDate: '2023-11-05',
      limits: [
        {
          name: 'Optical Limit',
          totalAvailable: 300,
          totalConsumed: null,
          totalLimit: 300,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Unlimited General Dental',
          totalAvailable: null,
          totalConsumed: null,
          totalLimit: null,
          unlimited: true,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Health and Wellbeing Limit',
          totalAvailable: 400,
          totalConsumed: null,
          totalLimit: 400,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Acupuncture',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Myotherapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Group Physiotherapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Group Exercise Physiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Remedial Massage',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Tests and Programs',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Med Prescribed Devices & Apps',
          totalAvailable: 1500,
          totalConsumed: null,
          totalLimit: 1500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Hearing Aids',
              consumed: null,
              subLimitMaximum: 1500,
              subLimitAvailable: 1500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Appliance Maintenance',
              consumed: null,
              subLimitMaximum: 100,
              subLimitAvailable: 100,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Blood Glucose Monitor',
              consumed: null,
              subLimitMaximum: 500,
              subLimitAvailable: 500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Blood Pressure Monitor',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Foot Orthotics Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Mobility Aids Limit',
              consumed: null,
              subLimitMaximum: 1000,
              subLimitAvailable: 1000,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Nebuliser and Spacer Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Non-Cosmetic Prostheses',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Irlen Lense Limit',
              consumed: null,
              subLimitMaximum: 100,
              subLimitAvailable: 100,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Orthopaedic Shoes Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Pap Machine For Sleep Apnoea',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Rental Of Appliances',
              consumed: null,
              subLimitMaximum: 200,
              subLimitAvailable: 200,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Splints and Braces Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Compression Garment Limit',
              consumed: null,
              subLimitMaximum: 1500,
              subLimitAvailable: 1500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'TENS Machine Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Join Fluid Rep Injects Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'EpiPen Limit',
              consumed: null,
              subLimitMaximum: 150,
              subLimitAvailable: 150,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Wig',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'External Breast Prosthesis',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Artificial Eye Limit',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Laser Refractive Eye Surgery',
          totalAvailable: 1500,
          totalConsumed: null,
          totalLimit: 1500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Major Dental',
          totalAvailable: 1100,
          totalConsumed: null,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Surgical Tooth Removal',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Orthodontic',
          totalAvailable: 1000,
          totalConsumed: null,
          totalLimit: 1000,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Physiotherapy Limit',
          totalAvailable: 850,
          totalConsumed: null,
          totalLimit: 850,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Chiro/Osteo Limit',
          totalAvailable: 750,
          totalConsumed: null,
          totalLimit: 750,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Chiropractic',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Osteopathy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Pharmacy & Travel Vaccinations',
          totalAvailable: 500,
          totalConsumed: null,
          totalLimit: 500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Travel Vaccinations',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Pharmacy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'School Accidents',
          totalAvailable: 800,
          totalConsumed: null,
          totalLimit: 800,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Flexi Limit',
          totalAvailable: 1300,
          totalConsumed: null,
          totalLimit: 1300,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Exercise Physiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Dietitian',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Psychology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Ante-Post Natal',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Podiatry',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Eye Therapy ',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Occupational Therapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Speech Therapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Audiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
      ],
    },
    {
      memberName: 'Seven Puddy',
      personCode: 'Member-1006',
      memberWaitingPeriodEndDate: '2023-11-05',
      limits: [
        {
          name: 'Optical Limit',
          totalAvailable: 300,
          totalConsumed: null,
          totalLimit: 300,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Unlimited General Dental',
          totalAvailable: null,
          totalConsumed: null,
          totalLimit: null,
          unlimited: true,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Health and Wellbeing Limit',
          totalAvailable: 400,
          totalConsumed: null,
          totalLimit: 400,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Acupuncture',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Myotherapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Group Physiotherapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Group Exercise Physiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Remedial Massage',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Tests and Programs',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Med Prescribed Devices & Apps',
          totalAvailable: 1500,
          totalConsumed: null,
          totalLimit: 1500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Hearing Aids',
              consumed: null,
              subLimitMaximum: 1500,
              subLimitAvailable: 1500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Appliance Maintenance',
              consumed: null,
              subLimitMaximum: 100,
              subLimitAvailable: 100,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Blood Glucose Monitor',
              consumed: null,
              subLimitMaximum: 500,
              subLimitAvailable: 500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Blood Pressure Monitor',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Foot Orthotics Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Mobility Aids Limit',
              consumed: null,
              subLimitMaximum: 1000,
              subLimitAvailable: 1000,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Nebuliser and Spacer Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Non-Cosmetic Prostheses',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Irlen Lense Limit',
              consumed: null,
              subLimitMaximum: 100,
              subLimitAvailable: 100,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Orthopaedic Shoes Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Pap Machine For Sleep Apnoea',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Rental Of Appliances',
              consumed: null,
              subLimitMaximum: 200,
              subLimitAvailable: 200,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Splints and Braces Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Compression Garment Limit',
              consumed: null,
              subLimitMaximum: 1500,
              subLimitAvailable: 1500,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'TENS Machine Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Join Fluid Rep Injects Limit',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'EpiPen Limit',
              consumed: null,
              subLimitMaximum: 150,
              subLimitAvailable: 150,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Wig',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'External Breast Prosthesis',
              consumed: null,
              subLimitMaximum: 300,
              subLimitAvailable: 300,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Artificial Eye Limit',
              consumed: null,
              subLimitMaximum: 1250,
              subLimitAvailable: 1250,
              subLimitConsumption: null,
              unlimited: false,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Laser Refractive Eye Surgery',
          totalAvailable: 1500,
          totalConsumed: null,
          totalLimit: 1500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Major Dental',
          totalAvailable: 1100,
          totalConsumed: null,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Surgical Tooth Removal',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Orthodontic',
          totalAvailable: 1000,
          totalConsumed: null,
          totalLimit: 1000,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Physiotherapy Limit',
          totalAvailable: 850,
          totalConsumed: null,
          totalLimit: 850,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Chiro/Osteo Limit',
          totalAvailable: 750,
          totalConsumed: null,
          totalLimit: 750,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Chiropractic',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Osteopathy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'Pharmacy & Travel Vaccinations',
          totalAvailable: 500,
          totalConsumed: null,
          totalLimit: 500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Travel Vaccinations',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Pharmacy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
        {
          name: 'School Accidents',
          totalAvailable: 800,
          totalConsumed: null,
          totalLimit: 800,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Flexi Limit',
          totalAvailable: 1300,
          totalConsumed: null,
          totalLimit: 1300,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [
            {
              name: 'Exercise Physiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Dietitian',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Psychology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Ante-Post Natal',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Podiatry',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Eye Therapy ',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Occupational Therapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Speech Therapy',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
            {
              name: 'Audiology',
              consumed: null,
              subLimitMaximum: null,
              subLimitAvailable: null,
              subLimitConsumption: null,
              unlimited: true,
              startPeriod: '2023-07-01',
              endPeriod: '2024-06-30',
            },
          ],
        },
      ],
    },
  ],
};

export const servicesAndLimitsHospital = {
  limitsAndConsumption: [
    {
      memberName: 'Elaine Benes',
      personCode: 'Member-1002',
      memberWaitingPeriodEndDate: '2023-11-05',
      limits: [
        {
          name: 'Member Excess',
          totalAvailable: 500,
          totalConsumed: null,
          totalLimit: 500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Home Nursing General Treatment',
          totalAvailable: 2200,
          totalConsumed: 1100,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Midwifery Birth',
          totalAvailable: 1700,
          totalConsumed: 400,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Midwifery Consultation',
          totalAvailable: 1100,
          totalConsumed: null,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
      ],
    },
    {
      memberName: 'David Puddy',
      personCode: 'Member-100200000000',
      memberWaitingPeriodEndDate: '2023-11-05',
      limits: [
        {
          name: 'Member Excess',
          totalAvailable: 500,
          totalConsumed: 100,
          totalLimit: 400,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Home Nursing General Treatment',
          totalAvailable: 2200,
          totalConsumed: 1100,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Midwifery Birth',
          totalAvailable: 1700,
          totalConsumed: 400,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Midwifery Consultation',
          totalAvailable: 1100,
          totalConsumed: null,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
      ],
    },
    {
      memberName: 'Seven Puddy',
      personCode: 'Member-1006',
      memberWaitingPeriodEndDate: '2023-11-05',
      limits: [
        {
          name: 'Member Excess',
          totalAvailable: 500,
          totalConsumed: null,
          totalLimit: 500,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Home Nursing General Treatment',
          totalAvailable: 2200,
          totalConsumed: 1100,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Midwifery Birth',
          totalAvailable: 1700,
          totalConsumed: 400,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
        {
          name: 'Midwifery Consultation',
          totalAvailable: 1100,
          totalConsumed: null,
          totalLimit: 1100,
          unlimited: false,
          startPeriod: '2023-07-01',
          endPeriod: '2024-06-30',
          modalities: [],
        },
      ],
    },
  ],
};

export const memberHistory = {
  members: [
    {
      name: 'Elane Benes',
      personCode: 'Member-1002',
      coveredOnMembership: 'Policy Holder',
      keepPrivate: false,
      insurableHistory: [
        {
          status: 'active',
          memberType: 'Policy Holder',
          startDate: '2023-11-08',
          endDate: null,
        },
        {
          status: 'terminated',
          memberType: 'Partner',
          startDate: '2022-11-02',
          endDate: '2022-12-31',
        },
        {
          status: 'suspended',
          memberType: 'Partner',
          startDate: '2022-10-29',
          endDate: '2022-11-01',
        },
        {
          status: 'active',
          memberType: 'Partner',
          startDate: '2021-11-12',
          endDate: '2022-10-29',
        },
      ],
      products: [
        {
          name: 'ADF Total Package Gold',
          code: 'J17',
          type: 'package',
          startDate: '2021-11-12',
          endDate: '2023-10-07',
        },
        {
          name: 'Advantage Hospital Silver Plus',
          code: 'J22',
          type: 'hospital',
          startDate: '2023-11-08',
          endDate: null,
        },
        {
          name: 'Essentials Extras',
          code: 'I5',
          type: 'extras',
          startDate: '2023-11-08',
          endDate: null,
        },
      ],
    },
    {
      name: 'David Puddy',
      personCode: 'Member-100200000000',
      coveredOnMembership: 'Spouse',
      keepPrivate: false,
      insurableHistory: [
        {
          status: 'active',
          memberType: 'Partner',
          startDate: '2023-11-08',
          endDate: null,
        },
        {
          status: 'terminated',
          memberType: 'Partner',
          startDate: '2023-10-08',
          endDate: '2023-11-07',
        },
      ],
      products: [
        {
          name: 'Advantage Hospital Silver Plus',
          code: 'J22',
          type: 'hospital',
          startDate: '2023-11-08',
          endDate: null,
        },
        {
          name: 'Essentials Extras',
          code: 'I5',
          type: 'extras',
          startDate: '2023-11-08',
          endDate: null,
        },
      ],
    },
    {
      name: 'Seven Puddy',
      personCode: 'Member-1006',
      coveredOnMembership: 'Son',
      keepPrivate: false,
      insurableHistory: [
        {
          status: 'active',
          memberType: 'Son',
          startDate: '2022-11-08',
          endDate: null,
        },
      ],
      products: [
        {
          name: 'ADF Total Package Gold',
          code: 'J17',
          type: 'package',
          startDate: '2022-11-08',
          endDate: '2023-10-07',
        },
        {
          name: 'Advantage Hospital Silver Plus',
          code: 'J22',
          type: 'hospital',
          startDate: '2023-11-08',
          endDate: null,
        },
        {
          name: 'Essentials Extras',
          code: 'I5',
          type: 'extras',
          startDate: '2023-11-08',
          endDate: null,
        },
      ],
    },
  ],
};
